import { useStyletron, withStyle } from "baseui";
import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE, SIZE } from "baseui/modal";

const ModalAutoSize = (props: { header: any, body: any, footer: any, setIsOpen: (val: boolean) => void, isOpen: boolean }) => {
    const [css,] = useStyletron();

    return (
        <>
            <Modal closeable onClose={() => props.setIsOpen(false)} isOpen={props.isOpen} animate
                autoFocus
                overrides={{
                    Dialog: {
                        style: {
                            minWidth: '60vw',
                            height: '80vh',
                            display: 'flex',
                            flexDirection: 'column',
                        },
                    },
                }}
                size={SIZE.default}
                role={ROLE.dialog}>
                <div className={css({ display: 'contents', width: '100%', height: '100%' })}>
                    <MyModalHeader>
                        {props.header}
                    </MyModalHeader>
                    <MyModalBody>
                        {props.body}
                    </MyModalBody>
                    <MyModalFooter>
                        {props.footer}
                    </MyModalFooter>
                </div>
            </Modal>
        </>
    )

}

const MyModalHeader = withStyle(ModalHeader, { flex: '0 1 auto' });
const MyModalBody = withStyle(ModalBody, { flex: '1 1 auto', overflowY: 'auto' });
const MyModalFooter = withStyle(ModalFooter, { flex: '0 1 auto' });

export default ModalAutoSize;